export default () => `
	<p class="phaeno-calendar__loading">Lädt …</p>
`;
